import { TypeDefinition } from "../generic";

export class EventLevels {
    public static MainEvent: TypeDefinition = { id: 0, name: "Main event" };
    public static SubEvent: TypeDefinition = { id: 1, name: "Sub event" };
    public static Session: TypeDefinition = { id: 2, name: "Session" };

    public static Values: TypeDefinition[] = [
        EventLevels.MainEvent,
        EventLevels.SubEvent,
        EventLevels.Session,
    ];

    public static isMainEvent = (level: number | { levelId: number }) => {
        const s = typeof level === "number" ? level : level.levelId;
        return s === EventLevels.MainEvent.id;
    }

    public static isSubEvent = (level: number | { levelId: number }) => {
        const s = typeof level === "number" ? level : level.levelId;
        return s === EventLevels.SubEvent.id;
    }

    public static isSession = (level: number | { levelId: number }) => {
        const s = typeof level === "number" ? level : level.levelId;
        return s === EventLevels.Session.id;
    }
}



// WEBPACK FOOTER //
// ./src/models/event/EventLevels.ts